module.exports = __webpack_public_path__ + "static/img/e101.ddaccc53.png";